var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5 18C15.2879 18 18.8183 16.3662 21.2757 13.5384C22.2414 12.4308 22.2414 10.5692 21.2757 9.46163C18.8183 6.63384 15.2879 5 11.5 5C7.71206 5 4.18166 6.63384 1.72432 9.46163C0.758559 10.5692 0.758559 12.4308 1.72432 13.5384C4.18166 16.3662 7.71206 18 11.5 18Z",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4939 8C9.56918 8 8 9.56918 8 11.5061C8 13.4308 9.56918 15 11.4939 15C13.4186 15 15 13.4308 15 11.5061C15 9.58144 13.4186 8 11.4939 8Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-eye.005ec656002d1c061ca32b25f63c79ab.svg";